import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

const DaysWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 0 17px;
  font-size: 14px;
  color: ${themeGet('colors.black.60')};
`;

const Days = () => {
  const { t } = useTranslation('shared');
  return (
    <DaysWrapper>
      <div>{t('days.sunday')}</div>
      <div>{t('days.monday')}</div>
      <div>{t('days.tuesday')}</div>
      <div>{t('days.wednesday')}</div>
      <div>{t('days.thursday')}</div>
      <div>{t('days.friday')}</div>
      <div>{t('days.saturday')}</div>
    </DaysWrapper>
  );
};

export default Days;
